/**
 * Coverage map mapbox.js
 */

console.log('Loaded radioDNSMap.js')

const coverageMapEl = document.querySelector('.js-coverage-map')

if (coverageMapEl) {
  // Grab and parse the isocodes from the data attribute
  const isocodesArray = JSON.parse(coverageMapEl.dataset.isocodes)
  console.log(isocodesArray)

  document.addEventListener('DOMContentLoaded', function (event) {
    mapboxgl.accessToken = 'pk.eyJ1IjoicmFkaW9kbnMiLCJhIjoiY2tzMGl6ajJ6MG8zMDJ2cGp2dTh4OHp2MyJ9.ZU16X4Rn7nuDuQQkT0wljg'

    // Create map
    const map = new mapboxgl.Map({
      container: coverageMapEl,
      style: 'mapbox://styles/radiodns/cks4jkcbw68kj17qorc5l8dhk',
      center: [0.0, 10.0],
      zoom: -1,
      // // minZoom: 3,
      // pitch: 0,
      // // bearing: 100,
      // attributionControl: false
    })

    // Prevent world from repeating x
    map.setRenderWorldCopies(false)

    // Add countries layer
    map.on('load', function () {
      map.addLayer({
        id: 'country-boundaries',
        source: {
          type: 'vector',
          url: 'mapbox://mapbox.country-boundaries-v1',
        },
        'source-layer': 'country_boundaries',
        type: 'fill',
        paint: {
          'fill-color': '#e95695',
          'fill-opacity': 0.9,
        },
      })
      map.addLayer({
        id: 'country-boundaries-hover',
        source: {
          type: 'vector',
          url: 'mapbox://mapbox.country-boundaries-v1',
        },
        'source-layer': 'country_boundaries',
        type: 'fill',
        paint: {
          'fill-color': '#cf3a7b',
          'fill-opacity': 0.9,
        },
      })
      map.addLayer({
        id: 'country-boundaries-lines',
        source: {
          type: 'vector',
          url: 'mapbox://mapbox.country-boundaries-v1',
        },
        'source-layer': 'country_boundaries',
        type: 'line',
        paint: {
          'line-opacity': 0.2,
          'line-color': '#14142b',
        },
      })
    })

    // Add countries by isocodes from the data attributes
    map.on('load', function () {
      map.setFilter('country-boundaries', ['in', 'iso_3166_1_alpha_3', ...isocodesArray])

        map.setFilter('country-boundaries-hover', ['==', 'name', ''])
        map.getCanvas().style.cursor = ''
    })

    // Interactive countries

    // When the user moves their mouse over the page, we look for features
    // at the mouse position (e.point) and within the countries layer (countries-fill).
    // If a feature is found, then we'll update the filter in the state-fills-hover
    // layer to only show that state, thus making a hover effect.
    // Thank you, https://stackoverflow.com/a/42935615/30727 !
    map.on('mousemove', function (e) {
      const features = map.queryRenderedFeatures(e.point, { layers: ['country-boundaries'] })

      if (features.length) {
        map.getCanvas().style.cursor = 'pointer'
        map.setFilter('country-boundaries-hover', ['==', 'name', features[0].properties.name])
      } else {
        map.setFilter('country-boundaries-hover', ['==', 'name', ''])
        map.getCanvas().style.cursor = ''
      }
    })

    // Reset the country-boundaries-hover layer's filter when the mouse leaves the map
    map.on('mouseout', function () {
      map.getCanvas().style.cursor = 'auto'
      map.setFilter('country-boundaries-hover', ['==', 'name', ''])
    })

    // Scroll to country accordion item on click
    map.on('click', function (e) {
      const features = map.queryRenderedFeatures(e.point, { layers: ['country-boundaries'] })

      if (features.length) {

        // Get countrie code
        const countryIsoCode = features[0].properties.iso_3166_1_alpha_3

        // Open the country accordion
        const collaspsedCountry = document.querySelector(`[data-country='${countryIsoCode}']`)
        new bootstrap.Collapse(collaspsedCountry, { show: true })

        // Scroll to the country accordion
        window.location = '#' + countryIsoCode
      }
    })

    // Prevent interactions
    map.boxZoom.disable()
    map.dragRotate.disable()

    // Add and position zoom
    const nav = new mapboxgl.NavigationControl({ showCompass: false })
    map.addControl(nav, 'top-right')

    //  FlyTo animation
    map.flyTo({
      center: [0.0, 40.0],
      zoom: 1,
      speed: 0.1,
      easing: function (t) {
        return t * (2 - t)
      },
    })
  })

  // Bootstrap accordion Back to top buttons - collapse all and return to map
  const backToTopButtons = Array.from(document.querySelectorAll('.js-back-to-top'))
  const accordionItems = Array.from(document.querySelectorAll('.collapse'))

  if (backToTopButtons.length) {
    // All buttons
    backToTopButtons.forEach((btn) => {
      // Close all opened
      btn.addEventListener('click', function () {
        accordionItems.forEach((collapseEl) => {
          collapseEl.classList.remove('show')
        })
        // Scroll to top
        window.location = '#map'
      })
    })
  }
}